/**
 * @desc 导入标的物
 */
import { PriceCompareGoodsEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type ImportGoodsPriceCompareParameter = object

const method = 'PUT'
const url = '/trade/member/priceCompare/importGoods'

export const importGoodsPriceCompareApi = (
  data?: ImportGoodsPriceCompareParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<PriceCompareGoodsEntity>>({
    method,
    url,
    data,
    ...config
  })
}

importGoodsPriceCompareApi.method = method
importGoodsPriceCompareApi.url = url
